import styled from '@emotion/styled';

export const Wrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;
